import React from "react";
import Table from "react-bootstrap/Table";
import "./UserUpdateCohort.css";
import Dropdown from "react-bootstrap/Dropdown";
import Box from "@mui/material/Box";
import Button from "react-bootstrap/Button";
import { FaArrowLeft } from "react-icons/fa";
import search from "../../../../../assests/search.svg";
import filter from "../../../../../assests/filterIcon.svg";
import Sidebar from "../../../Sidebar/Sidebar";
import { toastr } from "react-redux-toastr";
import { useNavigate } from "react-router-dom";

export const UpdateCohortComp = (props) => {
  const navigate = useNavigate();
  const cohortBack = () => navigate(-1);

  const handleSaveClick = () => {
    props.updateuserCohort();
    navigate(-1);
    toastr.success("Cohort updated successfully");
  };

  return (
    <div className="main-div">
      <Sidebar />

      <div className="main-content">
        <div className="topHeader">
          <FaArrowLeft className="backArrow" onClick={cohortBack} />
          <h2>Update Cohort</h2>
        </div>

        <div className="updatecohortsec">
          <div className="searchDivision">
            <input
              type="search"
              placeholder="Search by Cohort Name / Cohort ID"
              onChange={(e) => props.Search(e.target.value)}
            />
            <img className="cohortupdatesearchIcon" src={search} alt="Search" />
          </div>

          <div className="tableContainer">
            <Table striped>
              <thead>
                <tr>
                  <th>Cohort ID</th>
                  <th>Cohort Name</th>
                  <th>Area Name</th>
                  <th>
                    <Dropdown className="cohort-type1">
                      <Dropdown.Toggle variant="none" id="dropdown-basic">
                        <img src={filter} alt="" className="filterIcon" />
                        <span className="dropdownLabel">Cohort Type</span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {props.stagecohortsTypes?.map((item) => (
                          <Dropdown.Item
                            key={item.id}
                            id={item.id}
                            active={props.activeCohortType === item.id}
                            onClick={() =>
                              props.handleCohortTypeClick(item.id, item.type)
                            }
                          >
                            {item.name}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </th>
                  <th>
                        Actions </th>
                </tr>
              </thead>
              <tbody>
                {props.FilterCohortData?.length > 0 &&
                  props.FilterCohortData.sort((a, b) => {
                    const aChecked = props.userdetailsCohort?.find((dt) => dt.id === a.id);
                    const bChecked = props.userdetailsCohort?.find((dt) => dt.id === b.id);
                    return aChecked === bChecked ? 0 : aChecked ? -1 : 1;
                  }).map((el) => (
                    <tr key={el.id}>
                      <td>{el.id}</td>
                      <td>{el.name}</td>
                      <td>{el.area_name}</td>
                      <td className="ctypes">{el.type}</td>
                      <td>
                        <input
                          id={el.id}
                          type="checkbox"
                          className="cohortCheckbox"
                          onChange={(e) => {
                            if (props.userdetailsCohort?.find((dt) => dt.id === el.id)) {
                              props.removedCohort(e, el.id);
                            } else {
                              props.addCohorthandleClick(e);
                            }
                          }}
                          checked={props.userdetailsCohort?.some((dt) => dt.id === el.id)}
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>

          <Box className="usersrolebtncohort">
            <Button className="user-update-cohort-backbtn" onClick={cohortBack}>Back</Button>
            <Button className="user-update-cohort-savebtnupdate" onClick={handleSaveClick}>Save</Button>
          </Box>
        </div>
      </div>
    </div>
  );
};
